export const getColor = (status) => {
    switch (status) {
        case 'opened':
            return 'error';
        case 'completed':
            return 'success';
        case 'closed':
            return undefined;
        case 'delayed':
            return 'warning';
        default:
            return undefined;
    }
};
export const getStatusTranslate = (status) => {
    switch (status) {
        case 'opened':
            return 'Открыта';
        case 'completed':
            return 'Решена';
        case 'closed':
            return 'Закрыта';
        case 'delayed':
            return 'Отложена';
        default:
            return undefined;
    }
};
export const getRateTranslate = (rate) => {
    switch (rate) {
        case 'bad':
            return 'плохо';
        case 'normal':
            return 'нормально';
        case 'good':
            return 'хорошо';
        default:
            return 'без оценки';
    }
};
export const getTokenFromUrl = (url) => {
    if (url == null) {
        return;
    }
    const matched = url.match(/microline.okdesk.ru\/login\?token=([a-zA-Z0-9]+)/);
    if (matched) {
        return matched[1];
    }
    return;
};
